import React, { useState, lazy } from 'react';
import { ShoppingCartIcon } from 'lucide-react';
import { ExtraBonusModal } from './ExtraBonusModal';
export function SpecialOffer() {
  const [isExtraBonusModalOpen, setIsExtraBonusModalOpen] = useState(false);
  return <>
      <section className="bg-gradient-to-b from-orange-50 to-white py-8 sm:py-12 md:py-16" data-id="element-697">
        <div className="max-w-7xl mx-auto px-4" data-id="element-698">
          <div className="text-center mb-6 sm:mb-8 md:mb-12" data-id="element-699">
            <div className="inline-block bg-red-600 text-white px-4 py-2 sm:px-6 sm:py-3 rounded-full text-base sm:text-lg md:text-xl font-bold mb-3 sm:mb-4" data-id="element-700">
              🔥 OFERTA DE LANZAMIENTO
            </div>
            <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold mb-3 sm:mb-4 px-4" data-id="element-701">
              50 Recetas + Bonos Exclusivos
            </h2>
            <p className="text-base sm:text-lg md:text-xl text-gray-700 px-4" data-id="element-702">
              Todo lo que necesitas para cenas rápidas y deliciosas
            </p>
          </div>
          <div className="grid md:grid-cols-2 gap-6 sm:gap-8 mb-8 sm:mb-12" data-id="element-703">
            <div className="rounded-lg sm:rounded-xl overflow-hidden shadow-xl sm:shadow-2xl" data-id="element-704">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/mpVcH5Q1tNZqAEyhJAwYAU/mujer_caminando_con_libro_50_recetas.png" alt="Mujer profesional con el libro 50 Recetas de 15 Minutos" loading="lazy" className="w-full h-full object-cover" data-id="element-705" />
            </div>
            <div className="rounded-lg sm:rounded-xl overflow-hidden shadow-xl sm:shadow-2xl" data-id="element-706">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/7UZWDiPZSq8KeLP5Xu54mS/oferta_-6.png" alt="Bundle completo" loading="lazy" className="w-full h-full object-cover" data-id="element-707" />
            </div>
          </div>
          <div className="max-w-4xl mx-auto" data-id="element-708">
            <div className="bg-white rounded-xl sm:rounded-2xl shadow-xl p-4 sm:p-6 md:p-8 border-4 border-orange-200" data-id="element-709">
              <h3 className="text-xl sm:text-2xl font-bold mb-4 sm:mb-6 text-center" data-id="element-710">
                Lo Que Recibes Hoy:
              </h3>
              <div className="space-y-3 sm:space-y-4 mb-6 sm:mb-8" data-id="element-711">
                <div className="flex items-start gap-3 sm:gap-4" data-id="element-712">
                  <div className="flex-shrink-0 w-7 h-7 sm:w-8 sm:h-8 bg-orange-600 text-white rounded-full flex items-center justify-center font-bold text-sm sm:text-base" data-id="element-713">
                    ✓
                  </div>
                  <div data-id="element-714">
                    <div className="font-bold text-base sm:text-lg" data-id="element-715">
                      50 Recetas de 15 Minutos (Libro Principal)
                    </div>
                    <div className="text-sm sm:text-base text-gray-600" data-id="element-716">
                      50 recetas cronometradas, probadas y listas para usar
                    </div>
                  </div>
                </div>
                <div className="flex items-start gap-3 sm:gap-4" data-id="element-717">
                  <div className="flex-shrink-0 w-7 h-7 sm:w-8 sm:h-8 bg-orange-600 text-white rounded-full flex items-center justify-center font-bold text-sm sm:text-base" data-id="element-718">
                    🎁
                  </div>
                  <div data-id="element-719">
                    <div className="font-bold text-base sm:text-lg" data-id="element-720">
                      BONUS 1: Loncheras que Los Niños Devoran
                    </div>
                    <div className="text-sm sm:text-base text-gray-600" data-id="element-721">
                      Valor: $37 USD - HOY GRATIS
                    </div>
                  </div>
                </div>
                <div className="flex items-start gap-3 sm:gap-4" data-id="element-722">
                  <div className="flex-shrink-0 w-7 h-7 sm:w-8 sm:h-8 bg-orange-600 text-white rounded-full flex items-center justify-center font-bold text-sm sm:text-base" data-id="element-723">
                    🎁
                  </div>
                  <div data-id="element-724">
                    <div className="font-bold text-base sm:text-lg" data-id="element-725">
                      BONUS 2: 7 Días de Cena en 15 Minutos
                    </div>
                    <div className="text-sm sm:text-base text-gray-600" data-id="element-726">
                      Valor: $27 USD - HOY GRATIS
                    </div>
                  </div>
                </div>
                <div className="flex items-start gap-3 sm:gap-4" data-id="element-727">
                  <div className="flex-shrink-0 w-7 h-7 sm:w-8 sm:h-8 bg-orange-600 text-white rounded-full flex items-center justify-center font-bold text-sm sm:text-base" data-id="element-728">
                    🎁
                  </div>
                  <div data-id="element-729">
                    <div className="font-bold text-base sm:text-lg" data-id="element-730">
                      BONUS 3: Kit Imprimible de Menús
                    </div>
                    <div className="text-sm sm:text-base text-gray-600" data-id="element-731">
                      Valor: $19 USD - HOY GRATIS
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <ExtraBonusModal isOpen={isExtraBonusModalOpen} onClose={() => setIsExtraBonusModalOpen(false)} data-id="element-732" />
    </>;
}